module.exports = __webpack_public_path__ + "img/digital-art-ia.714ade65.svg";